import { render, staticRenderFns } from "./AccessControlSystem.vue?vue&type=template&id=e80da19c&scoped=true"
import script from "./AccessControlSystem.vue?vue&type=script&lang=js"
export * from "./AccessControlSystem.vue?vue&type=script&lang=js"
import style0 from "./AccessControlSystem.vue?vue&type=style&index=0&id=e80da19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80da19c",
  null
  
)

export default component.exports